import React from "react";
import "./index.scss";

const Card = ({ title, image, hightlighted = false, ...rest }) => {
  return (
    <>
      <div
        className={
          // `card ${hightlighted && "card-active"}`
          "cards"
        }
        {...rest}
      >
        <div
          className="card-image"
          dangerouslySetInnerHTML={{
            __html: image,
          }}
        />
        <div
          className="card-title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </div>
    </>
  );
};

export default Card;
